import * as d3 from 'd3';
import {wrap} from "@/utils/d3Utils.js"

export default function Legend(d, options) {
  const li = {
    w: 75, h: 20, s: 3
  };

  if ('undefined' !== typeof options)
    for (let i in options) if (options.hasOwnProperty(i) && 'undefined' !== typeof options[i])
      li[i] = options[i];


  d3.select(options.container).select("*").remove();


  const legend = d3.select(options.container).append("svg:svg")
    .attr("width", li.w)
    .attr("height", d.length * (li.h + li.s));

  const g = legend.selectAll("g")
    .data(d)
    .enter().append("svg:g")
    .attr("transform", (d, i) => "translate(0," + i * (li.h + li.s) + ")");


  g.append("svg:rect")
    .attr("y", li.h / 2)
    .attr("width", 25)
    .attr("height", 2)
    .style("fill", d => d.color);


  g.append("svg:text")
    .attr("x", 30)
    .attr("y", li.h / 2)
    .attr("dy", "0.35em")
    .attr("text-anchor", "left")
    .text(d => d.label);
}
